export const defaultChartType = 'priceMap';
